module.exports = __webpack_public_path__ + "img/index-carousel-2.31c18498.jpg";